function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.50033 0C4.55683 0.00238672 2.98188 1.57732 2.97949 3.52084V5.6875C2.97949 5.83708 3.10076 5.95834 3.25033 5.95834H4.33368C4.48325 5.95834 4.60452 5.83708 4.60452 5.6875V3.52084C4.60449 2.47378 5.4533 1.625 6.50033 1.625C7.54737 1.625 8.39618 2.47378 8.39618 3.52084V5.6875C8.39618 5.83708 8.51744 5.95834 8.66702 5.95834H9.75034C9.89991 5.95834 10.0212 5.83708 10.0212 5.6875V3.52084C10.0188 1.57732 8.44384 0.00238672 6.50033 0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.24967 5.4165H9.74967C10.4975 5.4165 11.1038 6.02278 11.1038 6.77066V11.6457C11.1038 12.3936 10.4975 12.9998 9.74967 12.9998H3.24967C2.50179 12.9998 1.89551 12.3936 1.89551 11.6457V6.77069C1.89551 6.02278 2.50179 5.4165 3.24967 5.4165Z",
  fill: "white"
});

function SvgPaymentLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLock);
export default __webpack_public_path__ + "static/media/paymentLock.2a8d899d.svg";
export { ForwardRef as ReactComponent };